export class Revision {
    id: number;
    shortDescription: string;
    atlTarget: number;
    btlTarget: number;
    totalTarget: number;
    allocationAmount: number;
}

export class Retailer {
    id: number;
    name: string;
    revisions: Revision[];
    total: number;
    totalAtl: number;
    totalBtl: number;
}

export class BrandAllocation {
    sectors: Array<Sector>;
    total: number;
    totalAtl: number;
    totalBtl: number;
    q1: number;
    q2: number;
    q3: number;
    q4: number;
    comment: string;
    changeReasonId = 0;
    revisions: Array<any> = [];
    brandId: number;
    budgetYear?: number;
    isMultiBrand?: boolean;
    sessionId: string;
}

export class Sector {
    id: number;
    name: string;
    retailers: Retailer[];
    total: number;
    totalAtl: number;
    totalBtl: number;
    totalAtlChange: number;
    totalBtlChange: number;
}


// WEBPACK FOOTER //
// ./src/app/client-core/dtos/brand-allocation.models.ts